export enum ProjectsView {
  Gantt = "gantt",
  Grid = "grid"
}
